"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HelmetTitle_1 = __importDefault(require("@/components/interactions/HelmetTitle"));
const principal_1 = require("@dfinity/principal");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const notistack_1 = require("notistack");
const react_2 = require("@connect2ic/react");
const authProvider_1 = require("@/components/authProvider/authProvider");
const format_1 = require("@/utils/format");
const principalToAccountId_1 = require("@/utils/principalToAccountId");
const FEE = 0.0001;
function Support() {
    const { principal, accountID, loggedIn } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(false);
    const [isTransferOpened, setIsTransferOpened] = (0, react_1.useState)(false);
    const [transferAmount, setTransferAmount] = (0, react_1.useState)("0");
    const [recipientAddress, setRecipientAddress] = (0, react_1.useState)("");
    const [amountError, setAmountError] = (0, react_1.useState)("");
    const [isTransfer, setIsTransfer] = (0, react_1.useState)(false);
    const [accountIdError, setAccountIdError] = (0, react_1.useState)("");
    const [token, setToken] = (0, react_1.useState)();
    const { enqueueSnackbar } = (0, notistack_1.useSnackbar)();
    const [name, setName] = (0, react_1.useState)("");
    const [balance, setBalance] = (0, react_1.useState)(0n);
    const [showBalance, setShowBalance] = (0, react_1.useState)(false);
    const [ledgerActor] = (0, react_2.useCanister)('icpLedger', { mode: 'connected' });
    const [errors, setErrors] = (0, react_1.useState)({
        name: "",
        email: "",
        principal: "",
        details: "",
    });
    const handleCloseTransfer = () => {
        setIsTransferOpened(false);
        setRecipientAddress('');
        setTransferAmount("0");
    };
    const handleSendOGY = async () => {
        setIsTransfer(true);
        try {
            if (parseFloat(transferAmount) <= 0) {
                setIsTransfer(false);
                return setAmountError("Invalid amount");
            }
            let accountId = recipientAddress;
            try {
                principal_1.Principal.fromText(recipientAddress);
                accountId = (0, principalToAccountId_1.getAccountId)(principal_1.Principal.fromText(recipientAddress));
            }
            catch (error) {
                accountId = recipientAddress;
            }
            let memo_bigint = 0n;
            const e8s = 10 ** 8;
            const amount_e8s = BigInt(Math.round(parseFloat(transferAmount) * e8s));
            const fee_e8s = BigInt(Math.round(FEE * e8s));
            const totalMinus = amount_e8s + fee_e8s;
            const blockHeight = await ledgerActor.send_dfx({
                to: accountId,
                fee: {
                    e8s: fee_e8s,
                },
                memo: memo_bigint,
                from_subaccount: [],
                created_at_time: [],
                amount: { e8s: amount_e8s },
            });
            console.log(blockHeight);
            setIsTransferOpened(false);
            enqueueSnackbar("Transfer was successfull", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            handleCheckBalance();
        }
        catch (e) {
            console.error({ e });
            setIsTransfer(false);
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsTransfer(false);
    };
    const handleCheckBalance = async () => {
        const balanceICP = (await ledgerActor.account_balance_dfx({
            account: accountID,
        }));
        console.log(balanceICP);
        setBalance(balanceICP.e8s);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HelmetTitle_1.default, { title: 'Recover Tokens', description: 'You can recover you tokens if you sent them to your principal by mistake.' }),
        loggedIn ? (react_1.default.createElement(origyn_art_ui_1.Container, { size: "sm", padding: '20px' },
            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h2", { style: { fontSize: '40px', fontWeight: '700', textAlign: 'center' } }, "Recover your tokens "),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("p", { style: { textAlign: 'center', color: '#69737C' } }, "The OGY dashboard only supports the OGY token. In case you accidentally sent other tokens here, you can recover those by following the steps below."),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null)),
            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                react_1.default.createElement(origyn_art_ui_1.Card, { style: { overflow: 'visible' } },
                    react_1.default.createElement(origyn_art_ui_1.Banner, { gap: 24, fullWidth: true, bgColor: "NAVIGATION_BACKGROUND", padding: "24px", flexFlow: 'column' },
                        react_1.default.createElement("p", null, "Token"),
                        react_1.default.createElement(origyn_art_ui_1.Select, { options: [{ value: 'icp', label: "ICP" }], selectedOption: token, handleChange: setToken, placeholder: "Chose token" }),
                        token?.value === "other" && (react_1.default.createElement(origyn_art_ui_1.TextInput, { label: "Name", value: name, onChange: (e) => setName(e.target.value), placeholder: "Enter your name", error: errors.name })),
                        react_1.default.createElement(origyn_art_ui_1.Button, { btnType: "filled", onClick: () => { handleCheckBalance(); setShowBalance(true); }, disabled: isLoading }, "Check balance"))),
                react_1.default.createElement("br", null),
                showBalance && (react_1.default.createElement(origyn_art_ui_1.Card, { style: { overflow: 'visible' } },
                    react_1.default.createElement(origyn_art_ui_1.Banner, { gap: 24, fullWidth: true, bgColor: "NAVIGATION_BACKGROUND", padding: "24px", flexFlow: 'column' },
                        react_1.default.createElement(origyn_art_ui_1.Card, { flexFlow: 'column' },
                            react_1.default.createElement(origyn_art_ui_1.Banner, { fullWidth: true, padding: "24px", flexFlow: 'column' },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 16 },
                                    "Your account ID: ",
                                    react_1.default.createElement("b", null, accountID))),
                            react_1.default.createElement(origyn_art_ui_1.HR, null),
                            react_1.default.createElement(origyn_art_ui_1.Banner, { fullWidth: true, padding: "24px", flexFlow: 'column' },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { align: "center", justify: "space-between" },
                                    react_1.default.createElement("p", { style: { fontSize: '22px', fontWeight: 600 } }, "Balance:"),
                                    react_1.default.createElement("b", { style: { fontSize: '22px', fontWeight: 600 } },
                                        (0, format_1.formatNatAmount)(balance),
                                        " ",
                                        token?.label)))),
                        react_1.default.createElement(origyn_art_ui_1.Button, { btnType: "filled", onClick: () => setIsTransferOpened(true), disabled: isLoading }, "Transfer Tokens"))))))) : (react_1.default.createElement(origyn_art_ui_1.Container, { size: "sm", padding: '20px' },
            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h2", { style: { fontSize: '40px', fontWeight: '700', textAlign: 'center' } }, "Recover your tokens "),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("p", { style: { textAlign: 'center', color: '#69737C' } }, "The OGY dashboard only supports the OGY token. In case you accidentally sent other tokens here, you can recover those by following the steps below."),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h2", { style: { fontSize: '32px', fontWeight: '700', textAlign: 'center' } }, "Log in with your wallet for recovering process")))),
        react_1.default.createElement(origyn_art_ui_1.Modal, { size: "md", isOpened: isTransferOpened, closeModal: handleCloseTransfer }, isTransfer ? (react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
            react_1.default.createElement("h2", null, "Transfer in progress"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 32 },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                        react_1.default.createElement("h2", null, "Transfer ICP"),
                        react_1.default.createElement("p", null, "You can only send ICP from your available balance.")),
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 8 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'space-between' },
                            react_1.default.createElement("b", null, "Amount"),
                            react_1.default.createElement("p", null,
                                "Balance: ",
                                (0, format_1.formatNatAmount)(balance),
                                " ICP")),
                        react_1.default.createElement(origyn_art_ui_1.TextInput, { value: transferAmount, type: "number", onChange: (e) => { setTransferAmount(e.target.value); }, error: amountError, placeholder: 'Enter amount to send ICP' }),
                        react_1.default.createElement(origyn_art_ui_1.TextInput, { label: "Recipient Address", value: recipientAddress, onChange: (e) => { setRecipientAddress(e.target.value); }, error: accountIdError, placeholder: 'Enter recipient address' })),
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                        react_1.default.createElement("b", null, "Transaction Fee"),
                        react_1.default.createElement("p", null, "0.0001 ICP")))),
            react_1.default.createElement(origyn_art_ui_1.HR, null),
            react_1.default.createElement(origyn_art_ui_1.Container, { padding: "32px 48px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'space-between' },
                    react_1.default.createElement("b", null, "Amount"),
                    react_1.default.createElement("p", null,
                        parseFloat(transferAmount) + 0.0001,
                        " ICP"))),
            react_1.default.createElement(origyn_art_ui_1.HR, null),
            react_1.default.createElement(origyn_art_ui_1.Container, { padding: "32px 48px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'flex-end' },
                    react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleCheckBalance }, "Cancel"),
                    react_1.default.createElement(origyn_art_ui_1.Button, { onClick: () => {
                            if (balance < BigInt(parseInt(transferAmount) * 10e7)) {
                                setAmountError("Your balance is insuficient!");
                            }
                            else {
                                handleSendOGY();
                            }
                        } }, "Transfer ICP"))))))));
}
exports.default = Support;
